/* Albandia Lashes - kohustuslik müügitingimustega nõustumine ostukorvis (Maksekeskuse nõue) */
(function () {
  var TERMS_URL = '/pages/muugitingimused';
  var PRIVACY_URL = '/pages/privaatsuspoliitika';
  var LABEL_HTML =
    'Olen tutvunud ja nõustun <a href="' + TERMS_URL + '" target="_blank" rel="noopener">müügitingimustega</a> ja ' +
    '<a href="' + PRIVACY_URL + '" target="_blank" rel="noopener">privaatsuspoliitikaga</a>.';

  function buildCheckbox(idSuffix) {
    var wrap = document.createElement('div');
    wrap.className = 'cart__terms-agreement';
    wrap.style.cssText = 'margin:0 0 1.2rem;display:flex;align-items:flex-start;gap:8px;font-size:1.4rem;line-height:1.5;text-align:left;';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.id = 'terms-agree-' + idSuffix;
    cb.style.cssText = 'width:18px;height:18px;margin-top:2px;flex:0 0 auto;cursor:pointer;';
    var lbl = document.createElement('label');
    lbl.setAttribute('for', cb.id);
    lbl.style.cssText = 'cursor:pointer;';
    lbl.innerHTML = LABEL_HTML;
    wrap.appendChild(cb);
    wrap.appendChild(lbl);
    return { wrap: wrap, cb: cb };
  }

  function gate(button, idSuffix) {
    if (!button || button.dataset.termsGated === '1') return;
    button.dataset.termsGated = '1';
    var made = buildCheckbox(idSuffix);
    var cta = button.closest('.cart__ctas') || button.parentNode;
    cta.parentNode.insertBefore(made.wrap, cta);
    var dyn = cta.parentNode.querySelector('.cart__dynamic-checkout-buttons');

    function sync() {
      var ok = made.cb.checked;
      button.disabled = !ok;
      if (dyn) {
        dyn.style.opacity = ok ? '1' : '0.45';
        dyn.style.pointerEvents = ok ? 'auto' : 'none';
      }
    }
    made.cb.addEventListener('change', sync);
    button.addEventListener('click', function (e) {
      if (!made.cb.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        made.wrap.style.outline = '2px solid #d02b2b';
        made.wrap.style.outlineOffset = '4px';
        made.cb.focus();
        made.wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, true);
    sync();
  }

  function scan() {
    gate(document.getElementById('checkout'), 'cart');
    gate(document.getElementById('CartDrawer-Checkout'), 'drawer');
  }

  function init() {
    scan();
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () { scan(); });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
